export default {
  close: 'Close',
  edit: 'Edit',
}
